"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** Rows that expand to reveal content */
var AccordionGroup = function AccordionGroup(props) {
  var Component = props.componentClass,
      elementProps = _objectWithoutProperties(props, ["componentClass"]);

  return _react2.default.createElement(Component, elementProps);
};

AccordionGroup.propTypes = {
  /** Contextual style variants. */
  bsStyle: _propTypes2.default.oneOf(["success", "warning", "danger", "info", "default", "primary"]),

  /** Elements that are passed to AccordionGroup ( AccordionContainer/AccordionItem ).  */
  componentClass: _propTypes2.default.element,

  /** Default to expanded on initial page load when true. */
  defaultExpanded: _propTypes2.default.bool,

  /** Value passed to event handler. */
  eventKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]),

  /** Accordion stays expanded when true. Useful for programmatically expanding/collapsing the accordion. */
  expanded: _propTypes2.default.bool,

  /** Component footer. */
  footer: _propTypes2.default.node,

  /** Component header. */
  header: _propTypes2.default.node,

  /** Set to true to support multiple accordions in a group open simultaneously. */
  independent: _propTypes2.default.bool,

  /** Callback fired before the component expands. */
  onEnter: _propTypes2.default.func,

  /** Callback fired after the component has expanded. */
  onEntered: _propTypes2.default.func,

  /** Callback fired after the component starts to expand. */
  onEntering: _propTypes2.default.func,

  /** Callback fired before the component collapses. */
  onExit: _propTypes2.default.func,

  /** Callback fired after the component has collapsed. */
  onExited: _propTypes2.default.func,

  /** Callback fired after the component starts to collapse. */
  onExiting: _propTypes2.default.func,

  /** Callback fired onSelect. */
  onSelect: _propTypes2.default.func
};

exports.default = AccordionGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/AccordionGroup/AccordionGroup.js
// module id = 576
// module chunks = 0